var _defs, _circle, _circle2, _circle3, _ellipse, _g, _path, _use, _path2, _ellipse2, _path3, _g2, _path4, _g3, _path5, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "85px",
    viewBox: "0 0 86 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tertiary-health-quiz copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.076923,1.000000),rotate(90.000000),scale(1.000000,12.710552),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.092308,1.000000),rotate(90.000000),scale(1.000000,10.263689),translate(-0.489155,-0.509384)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.1430861%",
    y1: "83.7378561%",
    x2: "22.6213315%",
    y2: "4.632213%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.283465%",
    y1: "83.7378561%",
    x2: "49.1425906%",
    y2: "5.28989558%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.2,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.1654574,38.4139384 C13.7271197,38.6018295 12.2887819,40.104959 10.8504442,40.104959 C3.17930947,40.104959 -2.19048483,23.0026863 0.877969056,16.1617772 C3.94642294,9.32086807 12.3846711,12.7413226 15.453125,12.7413226 L15.453125,12.7413226 C18.5215789,12.7413226 26.9598271,9.32086807 30.0282809,16.1617772 C33.0967348,23.0026863 27.7269405,40.104959 20.0558058,40.104959 C18.5215789,40.104959 16.9873519,38.3947317 15.453125,38.3947317 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.4425578%",
    x2: "99.5574422%",
    y2: "50.4425578%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.0797492%",
    y1: "83.7378561%",
    x2: "26.756691%",
    y2: "4.632213%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.4195416,39.1334085 C28.2173895,39.5829889 27.1102005,41.256496 26.0979745,44.1539295 C25.1249519,46.9391459 23.9875355,51.5770649 22.6857251,58.0676865 C22.5927793,58.5311053 22.8341756,58.9969012 23.2664014,59.1881518 L31.4251588,62.7982258 C31.8881088,63.0030712 32.4311808,62.8329207 32.6944787,62.4005337 L36.9475693,55.416123 C37.1767218,55.0398096 37.6236545,54.8558343 38.0513218,54.9617745 L48.7702516,57.6170289 C49.2377494,57.7328358 49.7218834,57.5018835 49.9260432,57.0656678 L53.6630796,49.0809719 C53.8894266,48.5973502 53.6995346,48.0211193 53.2300107,47.766816 L41.1890205,41.2451803 L41.1890205,41.2451803 L41.450304,40.5798732 C41.5520952,40.3206819 41.4244972,40.0280478 41.1653059,39.9262566 C41.1369027,39.9151019 41.1075455,39.9065487 41.0775958,39.9007024 L30.0203423,37.7422789 C29.7470379,37.6889287 29.4822319,37.8672369 29.4288817,38.1405413 C29.4226694,38.1723658 29.4195416,38.2047153 29.4195416,38.2371404 L29.4195416,39.1334085 L29.4195416,39.1334085 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.3%",
    y: "-5.5%",
    width: "108.1%",
    height: "110.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "77.3276635%",
    x2: "19.6413923%",
    y2: "13.2520925%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Dashboard_2nd_view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH---Dashboard_2nd_view-A",
    transform: "translate(-202.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-health-quiz-copy-2",
    transform: "translate(202.000000, 481.000000)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#62EBB9",
    cx: 43,
    cy: 41.65625,
    r: 40.3125
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.2,
    fill: "#62EBB9",
    cx: 43,
    cy: 41.65625,
    r: 37.625
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.25,
    fill: "#62EBB9",
    cx: 43,
    cy: 41.65625,
    r: 32.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "water",
    transform: "translate(8.062500, 36.281250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-small-01",
    transform: "translate(0.000000, 37.625000)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-1)",
    cx: 17.46875,
    cy: 1.34375,
    rx: 17.46875,
    ry: 1.34375
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-2)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 17.46875,
    cy: 0.895833333,
    rx: 9.70486111,
    ry: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6748666,0 C33.6105991,0.615736976 33.8700067,1.87345145 33.2542697,2.8091839 C33.1025665,3.03972651 32.9054092,3.23688375 32.6748666,3.38858696 L32.6748666,3.38858696 L32.6748666,3.38858696 L28.5007869,37.9964533 C28.4338655,38.551308 27.9630503,38.96875 27.4041744,38.96875 L6.18957559,38.96875 C5.63069975,38.96875 5.15988449,38.551308 5.09296306,37.9964533 L0.918883378,3.38858696 L0.918883378,3.38858696 C-0.0168490715,2.77284998 -0.276256657,1.51513551 0.33948032,0.579403059 C0.491183527,0.348860442 0.688340761,0.151703207 0.918883378,4.54525306e-13 L0.918883378,0 L0.918883378,0 L32.6748666,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9649444,18.3829327 C16.9649444,17.1020314 16.9649444,11.8410234 16.9649444,3.77116935 C16.9649444,-4.29868472 16.9649444,-10.0435887 16.9649444,-10.840594 C16.9649444,-10.840594 16.9649444,-4.29868472 16.9649444,3.77116935 C16.9649444,11.8410234 16.9649444,18.3829327 16.9649444,18.3829327 Z",
    id: "Oval",
    fill: "url(#linearGradient-4)",
    opacity: 0.100000001,
    transform: "translate(16.964944, 3.771169) rotate(-90.000000) translate(-16.964944, -3.771169) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3738289,10.5328578 L26.445093,36.6440937 C26.4210631,36.8583327 26.2398994,37.0203125 26.0243169,37.0203125 L7.56943306,37.0203125 C7.35385063,37.0203125 7.17268685,36.8583327 7.14865699,36.6440937 L4.21992114,10.5328578 L4.21992114,10.5328578 L29.3738289,10.5328578 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 21.7868492,
    cy: 33.7729167,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 15.8449812,
    cy: 31.175,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 9.24290573,
    cy: 16.8864583,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 11.8837359,
    cy: 12.3401042,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#linearGradient-6)",
    points: "10.6153299 4.96101502 5.3856785 4.96101502 9.90311328 35.7588981"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(47.031250, 29.770041)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4150179,7.06581273 C24.060939,6.96517244 26.2666235,5.21649419 26.2969944,4.3829476 C26.3273653,3.54940101 24.2431643,1.96389289 21.5972433,2.06453317 C18.9513222,2.16517346 16.7456376,3.91385171 16.7152668,4.74739831 C16.6848959,5.5809449 18.7690969,7.16645301 21.4150179,7.06581273 Z",
    id: "Oval",
    fill: "#575756",
    transform: "translate(21.506131, 4.565173) rotate(-30.000000) translate(-21.506131, -4.565173) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FF520B",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-7)",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2360007,16.9779043 C22.6760847,16.9779043 26.3244422,11.5684649 29.1161687,16.9779043 C31.9078952,22.3873436 20.7253855,29.564899 19.849622,30.4010272 C18.9738585,31.2371553 17.9252969,29.4995336 16.0009717,29.4995336 C14.0766466,29.4995336 13.6184029,31.4190035 12.1523215,30.4010272 C10.68624,29.3830508 -0.0650240103,21.8783554 3.35583273,16.9779043 C6.77668946,12.0774531 9.79591673,16.9779043 16.2360007,16.9779043 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-9)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(7.865854, 19.266516) rotate(-315.000000) translate(-7.865854, -19.266516) ",
    cx: 7.86585366,
    cy: 19.2665159,
    rx: 2.94969512,
    ry: 3.44131098
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.796875,14.573709 C19.3943392,14.573709 21.5,13.6712829 21.5,12.558084 C21.5,11.444885 19.3943392,10.542459 16.796875,10.542459 C14.1994108,10.542459 12.09375,11.444885 12.09375,12.558084 C12.09375,13.6712829 14.1994108,14.573709 16.796875,14.573709 Z",
    id: "Oval",
    fill: "url(#linearGradient-10)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0449947,12.6673065 C18.1949884,8.85507741 17.0028228,5.89105578 13.4868915,3.94850375 C13.0751435,3.72101298 12.5188306,3.81322183 12.2443319,4.154458 C11.9698333,4.49569416 12.0810958,4.95673844 12.4928438,5.18422922 C15.3486276,6.76204975 16.2803671,9.07858695 15.3064558,12.307103 C15.1864347,12.7049728 15.4783236,13.1081443 15.9584079,13.2076118 C16.4384921,13.3070792 16.9249736,13.0651763 17.0449947,12.6673065 Z",
    id: "Path-64",
    fill: "#575756",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "tape",
    transform: "translate(0.000000, 56.437500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.48666667,0 L19.096,0 C19.3787698,-1.62966271e-16 19.608,0.229230208 19.608,0.512 L19.608,13.248 C19.608,13.5307698 19.3787698,13.76 19.096,13.76 L1.48666667,13.76 C1.20389687,13.76 0.974666667,13.5307698 0.974666667,13.248 L0.974666667,0.512 C0.974666667,0.229230208 1.20389687,3.85010875e-16 1.48666667,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.554667, 7.568000)",
    fill: "#2CB5D6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.573333333,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.01333333,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.45333333,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.8933333,
    y: 0,
    width: 1,
    height: 6.192
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(75.921875, 7.390625) scale(-1, 1) translate(-75.921875, -7.390625) translate(65.843750, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    x: 0.974666667,
    y: 0,
    width: 18.6333333,
    height: 13.76,
    rx: 0.512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.554667, 7.568000)",
    fill: "#2CB5D6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.573333333,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.01333333,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.45333333,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.8933333,
    y: 0,
    width: 1,
    height: 6.192
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M18.7243122,-0.105811972 L13.416,5.49740649 L13.416,5.49740649 L19.608,5.49740649 L19.608,0.246313288 C19.608,-0.0364565041 19.3787698,-0.265686712 19.096,-0.265686712 C18.9554087,-0.265686712 18.8210032,-0.207874614 18.7243122,-0.105811972 Z",
    id: "Path-31",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7003122,-0.105811972 L66.392,5.49740649 L66.392,5.49740649 L72.584,5.49740649 L72.584,0.246313288 C72.584,-0.0364565041 72.3547698,-0.265686712 72.072,-0.265686712 C71.9314087,-0.265686712 71.7970032,-0.207874614 71.7003122,-0.105811972 Z",
    id: "Path-31",
    fill: "#575756",
    transform: "translate(69.488000, 2.748703) scale(-1, 1) translate(-69.488000, -2.748703) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(12.728000, 5.504000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F8F8",
    x: 0,
    y: 0,
    width: 60.544,
    height: 13.76,
    rx: 0.512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.128000, 7.568000)",
    fill: "#2CB5D6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1,
    height: 6.192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 41.28,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 20.64,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.44,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 44.72,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 24.08,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.88,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 48.16,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 27.52,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.32,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 51.6,
    y: 0,
    width: 1,
    height: 6.192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 30.96,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13.76,
    y: 2.752,
    width: 1,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 34.4,
    y: 0,
    width: 1,
    height: 6.192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 17.2,
    y: 0,
    width: 1,
    height: 6.192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 37.84,
    y: 2.752,
    width: 1,
    height: 3.44
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "runner",
    transform: "translate(6.718750, 1.343750)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.013405,39.643745 L22.1849389,63.666331 C22.1404575,63.8028274 22.0398994,63.9138897 21.908479,63.9716697 L8.76523698,69.7501942 C8.33405876,69.939765 8.01579758,70.3193753 7.90436184,70.7770147 L7.32314553,73.1639282 C7.12550242,73.9756002 7.62327121,74.7938118 8.43494323,74.9914549 C8.68197231,75.0516068 8.94017835,75.0485204 9.18569905,74.9824811 L26.9162255,70.2133804 C27.3029312,70.1093655 27.6326104,69.8562502 27.8329779,69.5095324 L36.9999302,53.646951 L36.9999302,53.646951 L51.1202329,57.2571226 C51.3650329,57.3197112 51.5257028,57.553833 51.4960598,57.8047626 L49.3792243,75.723871 C49.314201,76.2742962 49.5554254,76.8162045 50.0079321,77.1362569 L51.279763,78.0358074 C51.9617968,78.5182016 52.9057522,78.3563617 53.3881464,77.6743279 C53.4895988,77.5308893 53.5652861,77.3708726 53.6118138,77.2014549 L59.8604714,54.4486731 C60.0398159,53.795639 59.76325,53.1029785 59.1834451,52.7530581 L40.7114372,41.6049409 L40.7114372,41.6049409 L40.7114372,40.4644121 L44.7212181,30.8236716 C44.9350933,30.3094501 45.5253323,30.0659714 46.0395538,30.2798466 C46.0905234,30.3010459 46.1396662,30.3263947 46.1864869,30.3556375 L53.1522704,34.7062591 C53.6246338,35.0012833 54.2467242,34.8575214 54.5417483,34.3851581 C54.559189,34.3572338 54.5752517,34.3284721 54.5898786,34.2989764 L62.3019088,18.747424 C62.5493361,18.248479 62.3454408,17.6434247 61.8464958,17.3959974 C61.6629468,17.3049753 61.4560267,17.2720214 61.2532832,17.3015231 L59.4211618,17.5681193 C58.4821551,17.7047563 57.6616636,18.274059 57.2049795,19.1058299 L53.363802,26.1018688 C53.2297835,26.3459602 52.9232648,26.435192 52.6791734,26.3011735 C52.6374616,26.2782716 52.5992018,26.2495802 52.5655329,26.2159532 L44.6011717,18.2615035 C43.7921403,17.4534789 42.7707029,16.8912461 41.6552256,16.6399577 L35.4512425,15.2423593 C34.1253865,14.9436779 32.7375814,15.1000872 31.5114647,15.6863828 L18.2895643,22.0087346 C17.5134187,22.3798662 16.9319982,23.0638995 16.6907648,23.8897004 L13.1693074,35.94451 C13.0581141,36.3251518 13.180334,36.7356268 13.4816313,36.9934486 L14.4405054,37.8139625 C15.0217701,38.3113539 15.8961937,38.2433612 16.3935852,37.6620964 C16.4891344,37.5504351 16.5663056,37.4242799 16.6222039,37.2883635 L20.80183,27.1256211 C20.9152708,26.8497903 21.1449938,26.638325 21.4292544,26.5480625 L28.6887824,24.2429119 C29.2195906,24.074362 29.7865323,24.3680303 29.9550822,24.8988385 C29.9821839,24.984189 29.9977959,25.0727693 30.0015064,25.1622424 L30.5608962,38.6512434 L30.5608962,38.6512434 L30.013405,39.643745 Z",
    id: "Path-12",
    fill: "url(#linearGradient-12)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Path-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.9642151,55.3872763 C37.8593571,53.7468471 38.4698604,52.7714805 38.7957248,52.4611764 C39.2845214,51.9957203 41.3089997,54.6282939 38.6102299,55.09375 C38.6102299,55.09375 38.1081325,54.851304 37.5368136,55.0188758 C37.4019526,55.0584315 37.2110864,55.1812316 36.9642151,55.3872763 Z",
    id: "Path-2",
    fill: "url(#linearGradient-15)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.501674107
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7880254,14.7000608 C45.1632867,14.7000608 49.1217668,11.9912328 49.1217668,8.64972411 C49.1217668,5.30821545 45.1632867,2.59938746 41.7880254,2.59938746 C38.4127642,2.59938746 35.6765743,5.30821545 35.6765743,8.64972411 C35.6765743,11.9912328 38.4127642,14.7000608 41.7880254,14.7000608 Z",
    id: "Oval",
    fill: "url(#linearGradient-16)",
    transform: "translate(42.399171, 8.649724) rotate(-245.000000) translate(-42.399171, -8.649724) "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(32.432553, 38.833618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.265994, 1.923912) rotate(54.000000) translate(-2.265994, -1.923912) translate(1.539304, -0.349040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06382159,1.9095836e-14 C1.60584761,1.3442713 1.42227027,2.68854261 0.513089575,4.03281391",
    id: "Path-15",
    stroke: "#F8F8F8",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 0.513089575,
    cy: 4.03281391,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3.792846, 3.055545) rotate(33.000000) translate(-3.792846, -3.055545) translate(3.120971, 0.701295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.378089551,-3.8191672e-14 C0.378089551,-3.8191672e-14 1.34375,1.85398374 0.770616198,4.02473425",
    id: "Path-15",
    stroke: "#F8F8F8",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 0.67853151,
    cy: 4.19540919,
    rx: 1,
    ry: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0.000000, 80.625000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-17)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 43,
    cy: 2.6875,
    rx: 43,
    ry: 2.6875
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-18)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 43,
    cy: 2.015625,
    rx: 21.5,
    ry: 2.015625
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/health-icon.153b109c9d52b9d79462724ed4a36e21.svg";
export { ForwardRef as ReactComponent };